import script from "./VoucherBasket.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherBasket.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherBasket.vue?vue&type=style&index=0&id=7c95ecfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c95ecfa"]])

export default __exports__